import { useState, useEffect } from 'react';

import * as apiComms from '../apiComms';

const DeletePromotionItemModal = (props) => {

  const [ isConfirmDeleteCheckboxTicketed, setIsConfirmDeleteCheckboxTicketed ] = useState(false);
  const [ windowHeight, setWindowHeight ] = useState(100);

  useEffect(() => {
    setWindowHeight(window.innerHeight);
  }, []);

  return (
    <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: 'block', zIndex: 20000, width : '100%', height : '100%' }}>
      <div style={{ position : 'absolute', top : 0, bottom : 0, left : 0, right : 0, width : '100%', height : '100%', backgroundColor : 'black', opacity : 0.5 }}></div>
      <div style={{ position : 'absolute', top : 0, bottom : 0, left : 0, right : 0, width : '100%' }}>
        <div className="modal-dialog modal-lg" role="document" style={{ width : '80%', backgroundColor : 'white', height : { windowHeight }, maxHeight : { windowHeight } }}>
           <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{ props.modalTitle }</h5>
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
                onClick = { props.handleCancelPress }
                onPress = { props.handleCancelPress }>
              </button>
            </div>
            <div className="modal-body">
              <div>
                <div style={{ paddingLeft : 20, paddingRight : 20, height : '100%', display : 'flex', flexDirection : 'column', flexGrow : 10 }}>
                <table style={{ tableLayout : 'fixed', wordBreak : 'break-word', width : '100%' }}>
                  <tr>
                    <td style={{ whiteSpace : 'nowrap' }}>{ props.modalKeyword } Name:</td>
                    <td>{ props.promotion.title }</td>
                  </tr>
                  { props.isLinkUrl ? (
                    <tr>
                      <td style={{ whiteSpace : 'nowrap'}}>{ props.modalKeyword } Url:</td>
                      <td style={{ width : 100 }}><a href={ props.promotion.callToActionUrl } target='_newWindow'>{ props.promotion.callToActionUrl }</a></td>
                    </tr>
                  ) : null }
                  <tr>
                    <td style={{ whiteSpace : 'nowrap'}}>Image:</td>
                    <td><img style={{ width : 200 }} src={ props.promotion.imageUrl } /></td>
                  </tr>
                </table>
                </div>
              </div>
              <div style={{ display : 'flex', flexDirection : 'row', flexDirection : 'column', justifyContent : 'flex-start', padding : 20}}>
                <div style={{ color : 'red', display : 'flex', justifyContent : 'flex-start' }}>WARNING</div>
                <div style={{ display : 'flex', justifyContent : 'flex-start', color : 'red' }}>
                  Deleting this { props.modalKeyword } is permanent
                </div>
                <table>
                  <tr><td></td><td></td></tr>
                  <tr>
                    <td>Confirm Delete:</td>
                    <td>
                      <p>
                        <label>
                          <input type="checkbox" className="form-check-input" onChange = { () => { setIsConfirmDeleteCheckboxTicketed(!isConfirmDeleteCheckboxTicketed); }} />
                          <span></span>
                        </label>
                      </p>
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={ props.handleCancelPress }
                onPress={ props.handleCancelPress }>Cancel</button>
              { !isConfirmDeleteCheckboxTicketed ? (
                <button disabled type="button" className="btn btn-primary disabled" style={{ backgroundColor : '#cccccc', borderColor : '#aaaaaa' }} aria-disabled="true">Delete</button>
              ) : (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={ () => { props.handleDeleteButtonPress(props.promotion); }}
                  onPress={ () => { props.handleDeleteButtonPress(props.promotion); }}
                >Delete</button>
              ) }

            </div>

          </div>
        </div>
      </div>
    </div>
  );

};

export default DeletePromotionItemModal;
